import React, { useState, useRef } from 'react';
import { Card, Button, Col, Row } from 'react-bootstrap';
import ModalWindow from './modal.jsx';
import { apiFetch, API_URL } from '../../../utils/api.js';
import './cardsText.css';

export default function Catalog({ cards, onUpdate }) {
  const [formData, setFormData] = useState(null);
  const [show, setShow] = useState(false);
  let initialFormState = useRef(null);

  const deleteCard = async (id) => {
    if (window.confirm('Вы уверены, что хотите удалить эту услугу?')) {
      try {
        const res = await apiFetch(`/api/cards/${id}`, { method: 'DELETE' });
        if (res.ok) onUpdate();
      } catch (err) {
        console.error(err.message);
      }
    }
  };

  const editCard = (card) => {
    const cardData = { ...card, image: null };
    setFormData(cardData);
    initialFormState.current = cardData;
    setShow(true);
  };

  const isChanged = () => JSON.stringify(formData) !== JSON.stringify(initialFormState.current);

  const handleImage = (e) => setFormData(prev => ({ ...prev, image: e.target.files[0] }));
  const handleChange = (e) => setFormData(prev => ({ ...prev, [e.target.name]: e.target.value }));

  const handleClose = () => {
    if (isChanged()) {
      if (window.confirm('Данные не сохранены. Закрыть окно?')) {
        setShow(false);
        setFormData(null);
      }
    } else {
      setShow(false);
      setFormData(null);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const id = formData.card_id;
      const data = new FormData();
      data.append('title', formData.title);
      data.append('description', formData.description);
      data.append('price', formData.price);
      
      // Баг #12/13: передаем category_id
      if (formData.category_id) data.append('category_id', formData.category_id);

      // БАГ #18 ФИКС: Отправляем картинку только если это объект файла (новое фото)
      // Если там null или строка (путь), бэкенд оставит старое фото
      if (formData.image instanceof File) {
        data.append('image', formData.image);
      }

      const res = await apiFetch(`/api/cards/${id}`, { 
        method: 'PUT', 
        body: data 
      });

      if (res.ok) {
        setShow(false);
        setFormData(null);
        onUpdate();
      }
    } catch (err) {
      console.error("Ошибка при сохранении:", err);
    }
  };

  return (
      <Row className='g-4 mt-2'>
        {cards.map(card => (
          // Изменили размеры колонок: на обычных мониторах будет 3 в ряд, на очень больших 4.
          <Col key={card.card_id} xs={12} sm={6} lg={4} xxl={3}>
            <Card className="corp-card h-100 border-0 shadow-sm">
              <div className='ratio ratio-1x1 bg-light'>
                <Card.Img variant="top" className='object-fit-cover' src={`${API_URL}/${card.image}`} />
              </div>
              <Card.Body className="d-flex flex-column p-4">
                <div className="small text-muted text-uppercase fw-bold mb-2" style={{ fontSize: '0.65rem', letterSpacing: '1px' }}>
                  {card.category?.name || 'Без категории'}
                </div>
                <Card.Title className="fw-bold mb-2" style={{ fontSize: '1.1rem' }}>{card.title}</Card.Title>
                <Card.Text className='truncate-multiline small text-muted mb-4' style={{ flexGrow: 1 }}>
                  {card.description}
                </Card.Text>

                <div className='mt-auto pt-3 border-top'>
                  <div className="d-flex justify-content-between align-items-center mb-3">
                    <span className="text-muted small fw-bold text-uppercase" style={{ fontSize: '0.6rem' }}>Цена от:</span>
                    <span className="fw-bold text-dark fs-5">от {card.price} ₽</span>
                  </div>

                  <div className="admin-actions-grid">
                    <Button
                      className="admin-btn-action btn-admin-delete"
                      onClick={() => deleteCard(card.card_id)}
                    >
                      <i className="bi bi-trash3"></i>
                      <span>Удалить</span>
                    </Button>
                    <Button
                      className="admin-btn-action btn-admin-edit"
                      onClick={() => editCard(card)}
                    >
                      <i className="bi bi-pencil-square"></i>
                      <span>Изменить</span>
                    </Button>
                  </div>
                </div>
              </Card.Body>
            </Card>
          </Col>
        ))}
        {formData && (
          <ModalWindow
            show={show}
            handleClose={handleClose}
            formData={formData}
            handleChange={handleChange}
            handleSubmit={handleSubmit}
            handleImage={handleImage}
            title='Редактирование услуги'
          />
        )}
      </Row>
    );
}
